const pendingBannerShown = () => {};

const pendingBannerClicked = () => {};

const reviewsTrackingEvents = () => ({
  pendingBannerShown,
  pendingBannerClicked,
});

export default reviewsTrackingEvents;
